import * as React from "react"

import { cn } from "@/lib/utils"

// Inputs that should NOT get spell/grammar/autocorrect treatment.
const STRUCTURED_TYPES = new Set([
  "email", "password", "tel", "url", "number", "date", "datetime-local",
  "time", "month", "week", "search", "color", "hidden", "file",
]);

const Input = React.forwardRef(({ className, type, spellCheck, autoCorrect, autoCapitalize, ...props }, ref) => {
  const isFreeText = !type || type === "text";
  const isStructured = type && STRUCTURED_TYPES.has(type);
  return (
    <input
      type={type}
      className={cn(
        "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref}
      spellCheck={spellCheck ?? (isFreeText ? true : isStructured ? false : undefined)}
      autoCorrect={autoCorrect ?? (isFreeText ? "on" : "off")}
      autoCapitalize={autoCapitalize ?? (isFreeText ? "sentences" : "off")}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
